import { authenticatedPost } from '../../../../../../api/request';

export default async function createSchedules(idDoctorUser, motiveBody, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando un nuevo horario.');
    const url = `/doctor-profile-management/schedule/${idDoctorUser}`;
    return await authenticatedPost(url, onFail, motiveBody);
}
